import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Image,
  Input,
  Menu,
  Modal,
  Row,
  Select,
  message,
  Tooltip,
  Alert,
} from "antd";
import AuthService from "../auth/AuthService";
import config, { tms_uploads_cdn } from "../config";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, vehicleServiceTasks } from "../common/constants";
import dayjs from "dayjs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import DeleteIcon from "@mui/icons-material/Delete";

const Auth = new AuthService();

const CompleteReminderModal = ({ isModalOpen, setIsModalOpen, selectedRecord, searchFunction, allVehicle }) => {
  const { Option } = Select;
  const { TextArea } = Input;
  var layoutDispatch = useLoadingDispatch();

  const currentDate = new Date();
  const [selectedVehicle, setSelectedVehicle] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [dueDateNext, setDueDateNext] = useState(null);
  const [completionDate, setCompletionDate] = useState(currentDate);
  const [thresholdDays, setThresholdDays] = useState('');

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [notes, setNotes] = React.useState("");


  useEffect(()=>{
    if(selectedRecord) {
      setSelectedVehicle(selectedRecord?.vehicle_id);
      setSelectedTask(selectedRecord?.type)
      setDueDate(selectedRecord?.due_date ? new Date(selectedRecord?.due_date) : null)
      setCurrentItemFiles(selectedRecord?.files ? JSON.parse(selectedRecord?.files) : [])
      setNotes(selectedRecord?.notes || '')

    }
  },[selectedRecord])

//   useEffect(() => {
//     if (selectedTask && completionDate) {
//       const interval =selectedTask];
//       if (interval) {
//         const nextDueDate = dayjs(completionDate).add(interval.months || 0, 'month').add(interval.weeks || 0, 'week');
//         setDueDateNext(nextDueDate.toDate());
//       }
//     }
//   }, [selectedTask, completionDate]);

useEffect(() => {
    if (selectedTask && completionDate) {
      const interval = vehicleServiceTasks.filter((item)=> item.id === selectedTask);
      if (interval) {
        const nextDueDate = dayjs(completionDate).add(interval[0].interval || 0, interval[0].intervalType);
        setDueDateNext(nextDueDate.toDate());
        setThresholdDays(interval[0].thresholdDays)
      }
    }
  }, [selectedTask, completionDate]);  

  const handleCancel = () => {
    setIsModalOpen(false);
    resetState();
  };

  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    if(isEmptyOrUndefined(completionDate)) {
    message.error('Please enter completion date')
    return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      reminder : selectedRecord, 
      files: currentItemFiles,
      notes: notes,
      next_due_date: dueDateNext ? dayjs(dueDateNext).format(DEFAULT_DATE_FORMAT) : null,
      completion_date: completionDate ? dayjs(completionDate).format(DEFAULT_DATE_FORMAT) : null
    }
    try {
      const res = await Auth.fetch("/reminder/resolve-reminder", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {    
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, selectedRecord?.id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);    
        message.success(res?.message)
        setIsModalOpen(false);
        searchFunction()
        resetState()
      } else {
        message.error(res?.message)
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
      // setIsModalOpen(false);
    hideLoading(layoutDispatch);
    }
  };


  const resetState = () => {
    // setDueDate(null)
    setDueDateNext(null)
    setCompletionDate(new Date())
    setNotes('');
    setFiles([]);
    setCurrentItemFiles([]);
    setDeletedFiles([]);
  };

  useEffect(() => {
    message.config({
      top: window.innerHeight - 100, 
      duration: 3, 
    });
  }, [])

  const getThresholdDisplay = (thresholdDays) => {
    const weeks = thresholdDays / 7;
    const months = thresholdDays / 30;
  
    if (Number.isInteger(weeks)) {
      return `${weeks} week${weeks > 1 ? 's' : ''}`;
    } else if (Number.isInteger(months)) {
      return `${months} month${months > 1 ? 's' : ''}`;
    } else {
      return `${thresholdDays} day${thresholdDays > 1 ? 's' : ''}`;
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/reminders/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        title={"Resolve Service Task"}
        footer={[
          <>
            <Button onClick={handleCancel}>{"Cancel"}</Button>
            <Button type="primary" onClick={handleOk}>
              {"Resolve"}
            </Button>
          </>,
        ]}
      >
        <>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Vehicle<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedVehicle}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedVehicle(value);
              }}
            >
              {allVehicle.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.registration_number}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Service Task<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedTask}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedTask(value);
              }}
            >
              {vehicleServiceTasks.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Due Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={DATE_FORMAT}
              disabled
              value={dueDate ? dayjs(dueDate) : null}
              onChange={(date) => {
                const dateStr = date ? dayjs(date).format(DEFAULT_DATE_FORMAT) : null
                setDueDate(dateStr);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
            />
            </Col>
            
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
             Completion Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={DATE_FORMAT}
              value={completionDate ? dayjs(completionDate) : null}
              onChange={(date) => {
                const dateStr = date ? dayjs(date).format(DEFAULT_DATE_FORMAT) : null
                setCompletionDate(dateStr);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              // disabledDate={disabledDate}
              />
            </Col>
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} />
            </Col>
          </Row>
          <Divider />
          <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            // onChange={(e) => {
            //   handleSubmitImage(e);
            // }}
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            message.error("A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Old Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const lastHyphenIndex = item.lastIndexOf("-");
                        const dotBeforeExtensionIndex = item.lastIndexOf(".");
                        const newFileName =
                          item.slice(0, lastHyphenIndex) +
                          item.slice(dotBeforeExtensionIndex);
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${config.tms_uploads_cdn}/${config.env}/reminders/${selectedRecord?.id}/${item}`}
                              target="_blank"
                            >
                              {newFileName}
                            </a>
                          </li>
                        );
                      })}
                </ul>
      {/* <Image.PreviewGroup>
        {currentItemFiles?.length > 0 &&
          currentItemFiles
            .filter((item) => !files.some((file) => file.name === item))
            .map((item) => {
              const imageUrl = `${config.tms_uploads_cdn}/${config.env}/reminders/${selectedRecord?.id}/${item}`;
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={imageUrl}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteCurrentFile(item)}
                    />
                  </Tooltip>
                  
                </div>
              );
            })}
      </Image.PreviewGroup> */}
        <Divider />
      {files?.length > 0 && <h4>New Files:</h4>}
      <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>
      {/* <Image.PreviewGroup>
        {files?.length > 0 &&
          files.map((files) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={200}
                  height={150}
                  style={{ padding: "5px", border: "1px solid lightgrey" }}
                  src={URL.createObjectURL(files.file)}
                />
                <Tooltip title="Delete">
                  <CloseOutlined
                    style={{
                      fontSize: "30px",
                      position: "absolute",
                      right: 5,
                      top: 5,
                      color: "#c12828",
                    }}
                    onClick={() => handleDeleteFile(files.name)}
                  />
                </Tooltip>
              </div>
            );
          })}
      </Image.PreviewGroup> */}
            
          </>

          <>
        <Alert 
        // message="Informational Notes" 
        description={
        <>
        <span>{`Next Due Date: ${dayjs(dueDateNext).format(DATE_FORMAT)}  `}</span><br/>
        <span>{`Time Due Soon Threshold: ${getThresholdDisplay(thresholdDays)} `}</span>
        </>
        } 
        type="info" 
        showIcon />
        </>
        </>
      </Modal>
    </>
  );
};

export default CompleteReminderModal;
